import { ApplicationConfig } from '@angular/core';
import { environment } from '@environments';
import { provideGoogleTagManager } from 'angular-google-tag-manager';

export const googleTagManagerProvider: ApplicationConfig['providers'] = [
  provideGoogleTagManager({
    id: environment.gtmId,
  }),
];
